import * as React from 'react';
import { withStyles, WithStyles, createStyles } from '@material-ui/core';

import units from 'ha/theme/units';
import Row from 'ha/ui/next/Row';

import SearchAlertMobileTitle from './SearchAlertMobileTitle';
import SearchAlertConfirmation from '../../containers/SearchAlerts/SearchAlertConfirmation';
import SearchAlertConfirmationButton from '../../containers/SearchAlerts/SearchAlertConfirmationButton';

interface Props {
  handleClose: () => void;
}

const styles = createStyles({
  wrapper: {
    width: '100%',
    height: '100%',
    position: 'relative',
    fontSize: units.rem(1.125),
  },
  content: {
    padding: units.rem(1),
    flexGrow: 1,
  },
});

export const SearchAlertMobile: React.SFC<
  Props & WithStyles<typeof styles>
> = ({ classes, handleClose }) => (
  <Row wrap="nowrap" direction="column" className={classes.wrapper}>
    <SearchAlertMobileTitle onClose={handleClose} />

    <Row
      alignContent="flex-start"
      direction="column"
      className={classes.content}
    >
      <SearchAlertConfirmation />
    </Row>

    <SearchAlertConfirmationButton
      className="w-100 p-a-1 border-radius-0"
      onClick={handleClose}
    />
  </Row>
);

export default withStyles(styles)(SearchAlertMobile);
